import { extend } from "flarum/common/extend";
import PostStream from "flarum/forum/components/PostStream";

export default function() {
  extend(PostStream.prototype, "view", function (component) {
    const answersCount =
      document.querySelectorAll(
        ".PostStream > .PostStream-item[data-type='comment']"
      ).length - 1;
    const ansCountText = answersCount > 0 ? `(${answersCount})` : "";
    const ansFullText = app.translator.trans(
      "tolyod-advdiscus.forum.post.answers",
      { count: ansCountText }
    );
    if (answersCount > 0) {
      component.children[0].children.push(
        <div className="advDiscusAnswersText">
          <strong>{ansFullText}</strong>
        </div>
      );
    }
  });

}
